import { render } from "./ModalThemToaXe.vue?vue&type=template&id=f1f13c20&ts=true"
import script from "./ModalThemToaXe.vue?vue&type=script&lang=ts"
export * from "./ModalThemToaXe.vue?vue&type=script&lang=ts"

import "./ModalThemToaXe.vue?vue&type=style&index=0&id=f1f13c20&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__